import React from 'react'
import styles from './CuisineGenre.module.css'
import { adaptCuisineData } from './cuisineAdapter'
import { FormTitle } from '../../../Common/FormTitle'
import { CategorySelector } from '../../../Common/Pulldown/CategorySelector'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'

export const CuisineGenre = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const cuisineData = adaptCuisineData()

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollControll}>
                <div className={styles.selectionWrapper}>
                    <div className={styles.monthbox}>
                        <FormTitle
                            formTitleText='料理ジャンルはなんですか？'
                            dataViewLabel={dataViewLabel(
                                'EF_StepForm_料理ジャンル'
                            )}
                            dataClickLabel={dataClickLabel(
                                'EF_StepForm_料理ジャンル-戻る'
                            )}
                        />
                    </div>
                    <CategorySelector
                        categoryData={cuisineData}
                        formKey={['userResumesAttributes', 'genreId']}
                        displayFormKey={'genre'}
                        idField='genreId'
                        searchPlaceholder='料理ジャンルを検索する'
                        clickLabelPrefix='EF_StepForm_料理ジャンル'
                    />
                </div>
            </div>
        </div>
    )
}
